import { graphql } from '../graphql';

export const myOrganizationsQuery = graphql(`
  query MyOrganizations {
    organizations {
      id
      name
      slug
      role
      logo {
        url
      }
      storageUsedBytes
      storageLimitBytes
      ephemeralBytes
      subscription {
        tier
        billingStatus
        trialEndsAt
      }
    }
  }
`);

export const organizationUsersQuery = graphql(`
  query OrganizationUsers {
    users {
      id
      firstName
      lastName
      name
      email
      role
      joinedAt
      createdAt
      avatar {
        url
      }
    }
  }
`);

export const removeUserFromOrganizationMutation = graphql(`
  mutation RemoveUserFromOrganization($organizationId: ID!, $userId: ID!) {
    removeUserFromOrganization(organizationId: $organizationId, userId: $userId)
  }
`);

export const updateUserRoleInOrganizationMutation = graphql(`
  mutation UpdateUserRoleInOrganization($organizationId: ID!, $userId: ID!, $role: UserOrganizationRole!) {
    updateUserRoleInOrganization(organizationId: $organizationId, userId: $userId, role: $role)
  }
`);

export const inviteUserToOrganizationMutation = graphql(`
  mutation InviteUserToOrganization(
    $organizationId: ID!
    $email: String!
    $role: UserOrganizationRole!
    $firstname: String!
    $lastname: String
  ) {
    inviteUserToOrganization(
      organizationId: $organizationId
      email: $email
      role: $role
      firstname: $firstname
      lastname: $lastname
    )
  }
`);

export const inviteUsersToOrganizationMutation = graphql(`
  mutation InviteUsersToOrganization($organizationId: ID!, $invitees: [InviteUserInput!]!) {
    inviteUsersToOrganization(organizationId: $organizationId, invitees: $invitees)
  }
`);

export const organizationInvitationsQuery = graphql(`
  query OrganizationInvitations {
    invitations {
      id
      email
      role
      createdAt
      expiresAt
      acceptedAt
    }
  }
`);

export const revokeInvitationMutation = graphql(`
  mutation RevokeInvitation($id: ID!) {
    revokeInvitation(id: $id)
  }
`);

export const acceptInvitationMutation = graphql(`
  mutation AcceptInvitation($token: String!) {
    acceptInvitation(token: $token) {
      success
      error
      organization {
        id
        name
      }
    }
  }
`);

export const updateOrganizationMutation = graphql(`
  mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
    updateOrganization(id: $id, input: $input) {
      id
      name
      logo {
        url
      }
    }
  }
`);

export const deleteOrganizationMutation = graphql(`
  mutation DeleteOrganization($id: ID!, $password: String!) {
    deleteOrganization(id: $id, password: $password)
  }
`);

export const createOrganizationMutation = graphql(`
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      id
      name
      slug
      role
    }
  }
`);

export const slugAvailableQuery = graphql(`
  query SlugAvailable($slug: String!) {
    slugAvailable(slug: $slug)
  }
`);

export const inviteOnboardingUsersMutation = graphql(`
  mutation InviteOnboardingUsers($organizationId: ID!, $invitees: [OnboardingInviteInput!]!, $message: String) {
    inviteOnboardingUsers(organizationId: $organizationId, invitees: $invitees, message: $message)
  }
`);
